import Filter from "../../base-filter";

export default abstract class Package extends Filter {
	smallText = "Package";
	group = "Package";
	path = ["Package"];
}
